import getColor from "@insite/mobius/utilities/getColor";
import { purchasedProductsStyles } from "@waytek/Overrides/Widgets/Common/PurchasedProducts";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
};

purchasedProductsStyles.wrapper = {
    ...purchasedProductsStyles.wrapper,
    css: css`
        padding: 67px 0 60px;

        ${mediaQueriesBP.maxMD} {
            padding: 29px 0 38px;
        }
    `,
};

purchasedProductsStyles.headerContainer = {
    ...purchasedProductsStyles.headerContainer,
    css: css`
        display: none;
    `,
};

purchasedProductsStyles.titleText = {
    ...purchasedProductsStyles.titleText,
    css: css`
        padding: 0 0 27px;
        border-bottom: 12px solid ${localColors.globalIndustrialTaupe};
        width: 100%;
        margin-bottom: 0;
        ${mediaQueriesBP.maxMD} {
            padding: 0 0 10px;
            border-bottom: 6px solid ${localColors.globalIndustrialTaupe};
        }
    `,
};

purchasedProductsStyles.moreDataContainer = {
    gap: 0.0001,
};

purchasedProductsStyles.fullWidthGridItem = {
    width: 12,
    align: "middle",
    css: css`
        justify-content: center;
    `,
};

purchasedProductsStyles.viewMoreLink = {
    variant: "primary",
    css: css`
        margin-top: 20px;
    `,
};

purchasedProductsStyles.viewLessGridItem = {
    width: [12, 12, 6, 6, 6],
    align: "middle",
    css: css`
        justify-content: end;
        margin-top: 20px;

        ${mediaQueriesBP.maxMD} {
            justify-content: center;
        }
    `,
};

purchasedProductsStyles.viewLessLink = {
    variant: "secondary",
    css: css`
        margin-top: 20px;

        ${mediaQueriesBP.maxMD} {
            transform: translateX(50%);
        }
    `,
};

purchasedProductsStyles.paginationGridItem = {
    width: [12, 12, 6, 6, 6],
    align: "middle",
    css: css`
        justify-content: end;

        ${mediaQueriesBP.maxMD} {
            justify-content: center;
        }
    `,
};

purchasedProductsStyles.pagination = {
    mergeCss: true,
    cssOverrides: {
        linkList: css`
            [data-test-selector="pagination_firstButton"],
            [data-test-selector="pagination_previousButton"],
            [data-test-selector="pagination_nextButton"],
            [data-test-selector="pagination_lastButton"] {
                background-color: transparent;
            }
        `,
    },
};

purchasedProductsStyles.loadingSpinner = {
    size: 30,
    color: colorStrings.primaryMain,
    css: css`
        margin: 10px auto;
    `,
};
